import ChevronDownIcon from '@eduzz/houston-icons/ChevronDown';
import styled from '@eduzz/houston-styles';

interface IProps {
  direction: boolean;
}

export const Arrow = styled(ChevronDownIcon)<IProps>`
  & svg {
    transform: ${({ direction }) => (direction ? 'rotate(-180deg)' : 'rotate(0deg)')};
    transition: transform 0.4s ease-in-out;
    fill: #fff;
  }
`;
